import { Component, Inject } from '@angular/core';
import { StateService } from "@uirouter/angular";
import { CompetenceTypeDataService } from "../../core/competencetypes.dataservice";
import { MatDialog } from "@angular/material/dialog";
import { DetailsBase } from "../shared/details.base";

@Component({
    selector: "crew-competencetype",
    template: require('./competencetype.component.html')
})
export class CompetenceType extends DetailsBase<Nema.Crew.Model.CompetenceType> {
    constructor(
        stateService: StateService,
        dialog: MatDialog,
        @Inject(CompetenceTypeDataService.Id) competenceTypeDataService: CompetenceTypeDataService,
        @Inject('competenceType') competenceType: Nema.Crew.Model.CompetenceType,
        @Inject('$log') $log: ng.ILogService,
        @Inject("competenceGroups") public competenceGroups: Nema.Crew.Model.CompetenceGroup[]) {

        super(stateService, dialog, competenceType, competenceTypeDataService, $log);
    }

    public entityName = "Competence";

    public editStateName = "app.settings.competencetypes.edit";

    public listStateName = "app.settings.competencetypes";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/competencetypes/competencetype.component.ts